import httpClient, { uploadClient } from "./axiosConfig";
import { buildURI, getQueryString, buildSearchURI } from "./../utils/buildURI";
import { AUTH_CLIENT_ID, AUTH_CLIENT_SECRET } from "./../constants";

export const OTP_ACTION_GENERATE = "generate";
export const OTP_ACTION_VERIFY = "verify";
export const SEGMENT = "sme";
export const CONSENT_TYPE = "AECB";
export const EMAIL_IDENTIFIER = "AECB/FTS";

export const config = {
  load: (product, segment = SEGMENT) => {
    const query = getQueryString(product, segment);

    return httpClient.preAuth.request({
      method: "GET",
      url: `/bbg-loans/api/v1/config${query}`
    });
  }
};
export const dataList = {
  get: segment =>
    httpClient.preAuth.request({
      url: `/bbg-loans/api/v1/datalist?segment=${segment}`,
      method: "GET"
    })
};
export const otp = {
  generate: (payload, headers) =>
    httpClient.preAuth.request({
      url: buildURI("otpUri"),
      method: "POST",
      ...headers,
      data: {
        action: OTP_ACTION_GENERATE,
        ...payload
      }
    }),
  verify: (payload, headers) =>
    httpClient.preAuth.request({
      url: buildURI("otpUri"),
      method: "POST",
      ...headers,
      data: {
        action: OTP_ACTION_VERIFY,
        ...payload
      }
    })
};

export const prospect = {
  create: (data, headers) =>
    httpClient.preAuth.request({
      url: buildURI("createProspectUri"),
      method: "POST",
      ...headers,
      data
    }),
  update: (prospectId, data, headers) =>
    httpClient.postAuth.request({
      url: buildURI("updateProspectUri", prospectId),
      method: "PUT",
      ...headers,
      data
    }),
  get: (prospectId, headers) =>
    httpClient.postAuth.request({
      url: buildURI("getProspectUri", prospectId),
      method: "GET",
      ...headers
    })
};

export const getProspectDocuments = {
  retriveDocuments: (prospectId, headers) =>
    httpClient.postAuth.request({
      url: buildURI("getProspectDocumentsUri", prospectId),
      method: "GET",
      ...headers
    })
};

export const authToken = {
  get: headers =>
    httpClient.preAuth.request({
      url: buildURI("getTokenUri"),
      method: "POST",
      ...headers
    })
};

export const uploadProspectDocument = {
  requestClientToken: headers =>
    httpClient.postAuth.request({
      url: buildURI("documentUploaderToken"),
      method: "POST",
      data: {
        client_id: AUTH_CLIENT_ID,
        client_secret: AUTH_CLIENT_SECRET,
        module_id: "DAO"
      },
      headers: { ...headers?.headers, "Content-Type": "application/x-www-form-urlencoded" }
    }),
  send: ({ data, prospectId, source, onUploadProgress, headers }) =>
    uploadClient.request({
      url: buildURI("docUploaderUri", prospectId),
      method: "POST",
      ...headers,
      data,
      cancelToken: source.token,
      onUploadProgress
    })
};

export const downloadProspectDocument = {
  get: (prospectId, documentKey, headers) =>
    uploadClient.request({
      url: buildURI("getDocumentByIdUri", prospectId, documentKey),
      method: "GET",
      responseType: "blob",
      ...headers
    })
};

export const search = {
  searchApplication: (data, headers) =>
    httpClient.postAuth.request({
      url: buildURI("searchProspectUri"),
      method: "POST",
      ...headers,
      data
    }),
  searchUserApplications: (data, headers) =>
    httpClient.preAuth.request({
      url: buildURI("searchUserProspectUri"),
      method: "POST",
      ...headers,
      data
    })
};

export const authentication = {
  login: (data, headers) =>
    httpClient.preAuth.request({
      url: buildURI("authenticateUserUri"),
      method: "POST",
      data,
      ...headers
    }),
  logout: (data, headers) =>
    httpClient.postAuth.request({
      url: buildURI("logoutUri"),
      method: "POST",
      data,
      ...headers
    })
};

export const sendAecbFtsEmail = {
  sendMail: (payload, headers, prospectId) =>
    httpClient.postAuth.request({
      url: buildURI("sendAecbFtsEmailUri", prospectId),
      method: "POST",
      ...headers,
      data: {
        consentType: CONSENT_TYPE,
        emailIdentifier: EMAIL_IDENTIFIER,
        ...payload
      }
    })
};
export const sendAdhocEmail = {
  sendMail: (payload, headers, prospectId) =>
    httpClient.postAuth.request({
      url: buildURI("sendAdhocEmailUri", prospectId),
      method: "POST",
      ...headers,
      data: {
        emailIdentifier: EMAIL_IDENTIFIER,
        ...payload
      }
    })
};

export const getSignatories = {
  get: (headers, prospectId, signatoryId) =>
    httpClient.postAuth.request({
      url: buildURI("getSignatoryInfo", prospectId, undefined, signatoryId),
      method: "GET",
      ...headers
    })
};

export const authorizeSignatory = {
  authorize: (headers, payload) =>
    httpClient.postAuth.request({
      url: buildURI("authorizeSignatory", payload.prospectId, undefined, payload.signatoryId),
      method: "POST",
      ...headers,
      data: {
        isConsentDone: payload.isConsentDone,
        signatoryName: payload.signatoryName
      }
    })
};
export const createInvite = {
  send: (data, headers) =>
    httpClient.postAuth.request({
      url: buildURI("createInviteUri"),
      method: "POST",
      ...headers,
      data
    })
};

export const salesAssitRO = {
  update: (data, headers, prospectId) =>
    httpClient.postAuth.request({
      url: buildURI("updateByRO", prospectId),
      method: "PUT",
      ...headers,
      data
    }),
  get: (prospectId, headers) =>
    httpClient.preAuth.request({
      url: buildURI("updateByRO", prospectId),
      method: "GET",
      ...headers
    })
};

export const getDatalistSearch = {
  get: (headers, codeType, searchPattern) =>
    httpClient.preAuth.request({
      url: buildSearchURI("getDatalistSearchUri", codeType, searchPattern),
      method: "GET",
      ...headers
    })
};

export const postAuthToken = {
  get: (payload, headers) =>
    httpClient.postAuth.request({
      url: buildURI("postAuthToken"),
      method: "POST",
      data: payload,
      headers: {
        ...headers,
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: ""
      }
    })
};
